import { EntityType } from "@mapmycustomers/shared";
import { ActivityFilterEntityType } from "@mapmycustomers/shared/types/entity";
import { CombinedCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isSimpleCondition } from "@app/util/viewModel/assert";
import { fieldNameEntityTypePrefixRegEx } from "@app/util/viewModel/getFieldEntityType";

export const addEntityTypePrefixRecursively = (
  condition: CombinedCondition,
  entityType: ActivityFilterEntityType
): CombinedCondition => {
  // do not change anything with "own" activity fields
  if (entityType === EntityType.ACTIVITY) {
    return condition;
  }

  return {
    ...condition,
    conditions: condition.conditions.map((condition) => {
      if (isSimpleCondition(condition)) {
        return condition.fieldFilterName.startsWith(entityType)
          ? condition
          : {
              ...condition,
              fieldFilterName: `${entityType}.${condition.fieldFilterName}`,
            };
      } else {
        return addEntityTypePrefixRecursively(condition, entityType);
      }
    }),
  };
};

export const removeEntityTypePrefixRecursively = (
  condition: CombinedCondition
): CombinedCondition => {
  return {
    ...condition,
    conditions: condition.conditions.map((condition) => {
      if (isSimpleCondition(condition)) {
        return {
          ...condition,
          fieldFilterName: condition.fieldFilterName.replace(fieldNameEntityTypePrefixRegEx, ""),
        };
      } else {
        return removeEntityTypePrefixRecursively(condition);
      }
    }),
  };
};
